"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author ZSr
 * wrapper class output from stockout aggregation pipeline
 *
 */


var LostSaleDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LostSaleDTO, _DomainObject_1$Domai);

  /**
   * @param productId the internal id of product
   * @param amount - sum of stockout amount
   */
  function LostSaleDTO(productId, amount) {
    var _this;

    _classCallCheck(this, LostSaleDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LostSaleDTO).call(this));
    _this.productId = productId;
    _this.amount = amount;
    return _this;
  }

  return LostSaleDTO;
}(DomainObject_1.DomainObject);

exports.LostSaleDTO = LostSaleDTO;

LostSaleDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(LostSaleDTO.name);
  return {
    productId: builder.id('productId'),
    amount: builder.bigNum('amount')
  };
}();